import { motion } from 'motion/react';
import { Package } from 'lucide-react';
import { useLandingContent } from '../../lib/content';
import { capModalBody } from './capModalBody';

interface Props {
  open: boolean;
  onClose: () => void;
  /**
   * N2-closeout — the step's REAL cap (`getMaxSelections`). The copy reflects
   * this number instead of the old hardcoded "6 items"; a `{max}` token in a
   * CMS-authored body is substituted with it.
   */
  max?: number;
}

export function MaxMerchModal({ open, onClose, max }: Props) {
  const { modals } = useLandingContent('modals');
  const cms = modals.maxMerch;
  const m = {
    title: cms?.title ?? 'Selection Limit',
    body: capModalBody(cms?.body, max),
    cta: cms?.cta ?? 'Got it',
  };
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0 bg-black/60 backdrop-blur-md"
        onClick={onClose}
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        className="relative bg-white rounded-3xl p-8 max-w-sm w-full shadow-2xl text-center"
      >
        <div className="w-16 h-16 bg-[#57c858]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Package className="w-8 h-8 text-[#356d4e]" />
        </div>
        <h3 className="text-2xl font-bold mb-4 text-[#444444]">{m.title}</h3>
        <p className="text-gray-600 mb-8 leading-relaxed">{m.body}</p>
        <button
          onClick={onClose}
          className="w-full py-4 bg-linear-to-br from-[#356d4e] to-[#57c858] text-white rounded-xl font-bold hover:scale-105 transition-all shadow-lg"
        >
          {m.cta ?? 'Got it'}
        </button>
      </motion.div>
    </div>
  );
}
